
  import { defineComponent } from "vue";

  import baseProcessComponent from "@/components/processComponents/BaseProcessComponent.vue";

  export default defineComponent({
    name: "FormTemplate",

    extends: baseProcessComponent,

    computed: {
      value: {
        get() {
          return this.$attrs.modelValue || {};
        },

        set(value: any) {
          this.$emit("update:modelValue", value);
        },
      },
    },
  });
